import {
    EntityPermissionOperationNames,
    EntityType,
    IEntityPermission,
    InstanceFactory,
    REPORT_BUG_LINK
} from "@amzn/ask-legal-domain";
import { Icon } from "@amzn/awsui-components-react";
import * as React from "react";
import { useAPI2 } from "../../hooks/api-hook";
import { AppContext } from "../../setup/context";
import "../../styles/component/layout/Footer.scss";

export type FooterType = "InstanceHome" | "AdminPortal" | "LivePage";

export const SherpaFooter = (props: {
    variant: FooterType;
    entityId?: string;
}) => {
    const context = React.useContext(AppContext);
    const isAuthorizedRunner = useAPI2(
        context.getEntityPermissionAPI().isAuthorized
    );
    const checkPageAdminAccessRunner = useAPI2(
        context.getPageAPI().checkAdminAccess
    );
    const loadInstanceRunner = useAPI2(
        context.getInstanceAPI().load
    );

    const [feedbackLink, setFeedbackLink] = React.useState<string>();
    const [adminLink, setAdminLink] = React.useState<string>();

    React.useEffect(() => {
        if (!props.entityId) return;
        const instanceId = InstanceFactory.fromEntityId(props.entityId);
        loadInstanceRunner.invoke(instanceId);
        if (props.variant === "InstanceHome") {
            isAuthorizedRunner.invoke(
                IEntityPermission.IsAuthorizedInput.create(
                    instanceId,
                    EntityType.Instance,
                    EntityPermissionOperationNames.CAN_VIEW
                )
            );
        } else if (props.variant === "LivePage") {
            checkPageAdminAccessRunner.invoke(props.entityId);
        }
    }, [props.entityId]);

    React.useEffect(() => {
        if (isAuthorizedRunner.status === "Succeeded" && isAuthorizedRunner.output) {
            setAdminLink(`${window.location.origin}/#/instance/${InstanceFactory.fromEntityId(props.entityId)}/admin`);
        }
    }, [isAuthorizedRunner.status]);

    React.useEffect(() => {
        if (checkPageAdminAccessRunner.status === "Succeeded") {
            setAdminLink(`${window.location.origin}/#/page/${props.entityId}/admin`);
        }
    }, [checkPageAdminAccessRunner.status]);

    React.useEffect(() => {
        if (loadInstanceRunner.status === "Succeeded") {
            if (!!loadInstanceRunner.output.feedbackTicketTemplate && loadInstanceRunner.output.feedbackTicketTemplate.length > 0) {
                setFeedbackLink(loadInstanceRunner.output.feedbackTicketTemplate);
            }
        }
    }, [loadInstanceRunner.status]);

    return (
        <div className={`sherpa-footer ${props.variant === "InstanceHome" ? "footer-instance-home" : "footer-other"}`} >
            <div className="sherpa-footer-row awsui-polaris-dark-mode">
                <a target="_blank" rel="noopener noreferrer" className="sherpa-footer-item" href={REPORT_BUG_LINK}>
                    <Icon name="bug" /><div className="sherpa-footer-item-text">Report a technical bug</div>
                </a>
                {feedbackLink &&
                    <a target="_blank" rel="noopener noreferrer" className="sherpa-footer-item" href={feedbackLink}>
                        <Icon name="contact" /><div className="sherpa-footer-item-text">Provide content feedback</div>
                    </a>}
                {adminLink &&
                    <a target="_blank" rel="noopener noreferrer" className="sherpa-footer-item" href={adminLink}>
                        <Icon name="user-profile" /><div className="sherpa-footer-item-text">Admin Portal</div>
                    </a>}
            </div>
        </div>
    );
};